import { SIGN_IN_WITH_SLACK_URL } from 'config';

import React, { Component, PropTypes } from 'react';
import { firebase as fb } from 'redux-firebasev3';
import { browserHistory } from 'react-router';

import Loading from './components/Loading';
import SlashCommand from './components/SlashCommand';
import ErrorPage from './components/ErrorPage';
import SignInWithSlackButton from './components/SignInWithSlackButton';
import Page from './containers/Page';
import ContactSupport from './components/ContactSupport';
import fetchJSON from './utils/fetchJSON';

@fb()
export default class VerifySignInWithSlack extends Component {
  static propTypes = {
    firebase: PropTypes.object,
    location: PropTypes.shape({
      query: PropTypes.shape({
        code: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };

  state = {
    errorMessage: '',
  };

  componentDidMount() {
    const {
      firebase,
      location: { query: { code } },
    } = this.props;

    // TODO DRY with VerifyAddToSlack
    if (!code) {
      return null;
    }

    return fetchJSON(`${SIGN_IN_WITH_SLACK_URL}?code=${code}`)
      .then(({ errorMessage, loginToken }) => {
        if (errorMessage) {
          return this.setState({
            errorMessage,
          });
        }

        return firebase.login({ token: loginToken }).then(() => (
          // TODO send them to the exact resource they wanted.
          browserHistory.replace('dashboard')
        ));
      })
      .catch((error) => this.setState({
        errorMessage: error.toString(),
      }));
  }

  render() {
    const { errorMessage } = this.state;
    const {
      location: { query: { code } }
    } = this.props;

    if (!code || errorMessage) {
      if (Raven) {
        const error = !code ? 'Missing Sign in Code' : errorMessage;
        Raven.captureMessage('Sign in with Slack error', {
          extra: { error }
        });
      }

      return (
        <ErrorPage
          subtitle="Please try signing in again:"
          title="Oops! Sign in with Slack didn’t work."
        >
          <div className="mt4">
            <SignInWithSlackButton />
            <div className="mt4">
              or try a magic link with the
              {' '}<SlashCommand suffix=" dashboard" />{' '}
              command
            </div>
            <ContactSupport className="mt3" />
          </div>
        </ErrorPage>
      );
    }

    return (
      <Page pageTitle="Sign in with Slack">
        <div className="tc">
          <Loading message="Signing in" />
        </div>
      </Page>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/VerifySignInWithSlack.jsx
 **/